import { ReactNode } from "react";

import { Language } from "../../../../../../services";
import { getDefaultColumnLabelCellHelpers } from "../../../../../../utils";
import {
	ColumnId,
	translationTablePath,
	defaultColumns,
} from "../../../../../../constants/tables/orderWidgetExecutors";

import online from "./online";
import alias from "./alias";
import carCallSigns from "./carCallSigns";
import executorGroup from "./executorGroup";
import company from "./company";
import taxiService from "./taxiService";
import status from "./status";
import isWorking from "./isWorking";

export interface Column {
	render: (options: Column.Options) => ReactNode;
	label: string | string[];
}

export declare namespace Column {
	interface Options {
		width?: number;
		language: Language;
		onResize?: (width: number, columnId: ColumnId) => void;
	}
}

const createLabel = (id: ColumnId, tPath: string): [string, string] => [
	`${translationTablePath}${tPath}`,
	getDefaultColumnLabelCellHelpers(id),
];

export const columns: Record<ColumnId, Column> = {
	[ColumnId.Online]: {
		render: online,
		label: createLabel(ColumnId.Online, "str150"),
	},
	[ColumnId.Alias]: {
		render: alias,
		label: createLabel(ColumnId.Alias, "str151"),
	},
	[ColumnId.CarCallSigns]: {
		render: carCallSigns,
		label: createLabel(ColumnId.CarCallSigns, "str152"),
	},
	[ColumnId.ExecutorGroup]: {
		render: executorGroup,
		label: createLabel(ColumnId.ExecutorGroup, "str153"),
	},
	[ColumnId.Company]: {
		render: company,
		label: createLabel(ColumnId.Company, "str154"),
	},
	[ColumnId.TaxiService]: {
		render: taxiService,
		label: createLabel(ColumnId.TaxiService, "str155"),
	},
	[ColumnId.Status]: {
		render: status,
		label: createLabel(ColumnId.Status, "str156"),
	},
	[ColumnId.IsWorking]: {
		render: isWorking,
		label: createLabel(ColumnId.IsWorking, "str157"),
	},
};

export const defaultColumnIds = defaultColumns;

export const disabledColumnsIds = [];

export { ColumnId };

export default columns;
